import { formatNumber } from '@angular/common';
import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';

/** Sentinel values the tariff backends use in place of a real number. */
const SPECIAL_NUMERIC_LABELS: Record<number, string> = {
  [-1]: 'keine Angabe',
  [-11]: 'nicht relevant',
  [-111]: 'unbekannt',
  7777777: 'bis VSU',
  666666: 'Festzuschuss',
  88888888: 'erfüllt',
  999999999: 'unbegrenzt',
};

/** The prose a sentinel stands for, or null when the number is a real value. */
export function getSpecialNumericLabel(value: number | null | undefined): string | null {
  return value == null ? null : (SPECIAL_NUMERIC_LABELS[value] ?? null);
}

@Pipe({
  name: 'specialNumericLabel',
})
export class SpecialNumericLabelPipe implements PipeTransform {
  private readonly locale = inject(LOCALE_ID);

  transform(value: number | null | undefined): string | null {
    if (value == null) return null;

    const label = getSpecialNumericLabel(value);
    if (label) return label;

    return formatNumber(value, this.locale);
  }
}
